export default "__VITE_ASSET__8c2a466c__"